var React = require('react');

function ArrowRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#fff","d":"M15.756 46.887L11 42.134a.743.743 0 1 0-1.05 1.05l3.485 3.485H.743a.743.743 0 0 0 0 1.485h12.694l-3.485 3.487A.743.743 0 0 0 11 52.691l4.753-4.753a.743.743 0 0 0 .003-1.051z","opacity":"0.7","transform":"translate(0 -41.916)"}));
}

ArrowRightInline.defaultProps = {"width":"15.973","height":"10.992","viewBox":"0 0 15.973 10.992"};

module.exports = ArrowRightInline;

ArrowRightInline.default = ArrowRightInline;
